import React, { useEffect, useState } from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import LayoutClassic from 'components/layouts/layoutClassic'
import Breadcrumb from 'components/blog/breadcrumb'

function LayoutContent(props) {
  const {
    data,
    dataHeader,
    dataFooter,
    breadcrumbisDark = false,
    headerIsTransparent = false,
    children,
    isDark = false,
    breadcrumbHasBorder = false,
    breadcrumbLinks = [],
    pageClassName,
  } = props

  const breakpoints = useBreakpoint()
  const [progress, setProgress] = useState(0)

  function setSummaryActiveLink() {
    if (document.querySelector('.article__sidebar__summary')) {
      const headings = document.querySelectorAll('h2')
      let activeId = null

      for (const heading of headings) {
        const rect = heading.getBoundingClientRect()
        if (rect.top >= 0 && rect.top <= 100) {
          activeId = heading.id
          break
        }
      }

      if (activeId) {
        const links = document.querySelectorAll('.article__sidebar__summary a')
        links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${activeId}`))
      }
    }
  }

  useEffect(() => {
    const html = document.querySelector('html')
    html.classList.add('smooth-scroll')

    const handleScroll = () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight - 500
      const scrolled = (winScroll / height) * 100
      setProgress(scrolled)
      setSummaryActiveLink()
    }
    if (breakpoints.md) {
      window.addEventListener('scroll', handleScroll)
    }

    return () => {
      html.classList.remove('smooth-scroll')
      window.removeEventListener('scroll', handleScroll)
    }
  })

  return (
    <LayoutClassic
      title={data.page_title.text}
      description={data.page_description.text}
      thumbnail={data.page_thumbnail.url}
      dataFooter={dataFooter}
      dataHeader={dataHeader}
      headerIsDark={!isDark}
      headerIsTransparent={headerIsTransparent}
      headerNoSticky
      footerIsDark={isDark}
      pageClassName={pageClassName}
    >
      <div className={`${!isDark ? 'page__bg-white' : ''}`}>
        {isDark && <div className="page__bg-dark"></div>}
        <div className={`${headerIsTransparent ? '' : 'article'}`}>
          <div className={`article-progress ${progress > 3 && progress < 100 ? '' : 'is-hide'}`}>
            <div style={{ width: `${progress}%` }}></div>
          </div>
          <Breadcrumb
            className={`${breadcrumbisDark ? 'is-dark' : ''} ${breadcrumbHasBorder ? 'has-border' : ''}`}
            title={data.title.text}
            links={breadcrumbLinks}
          />
          {children}
        </div>
      </div>
    </LayoutClassic>
  )
}

export default LayoutContent
